import { render, staticRenderFns } from "./gradeResultadosProdutos.vue?vue&type=template&id=10d0a29a&scoped=true"
import script from "./gradeResultadosProdutos.vue?vue&type=script&lang=js"
export * from "./gradeResultadosProdutos.vue?vue&type=script&lang=js"
import style0 from "./gradeResultadosProdutos.vue?vue&type=style&index=0&id=10d0a29a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0a29a",
  null
  
)

export default component.exports